import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "../mock";

// Global, reusable site footer. Explore links navigate to the home page
// anchors via React Router so the footer works on any page.
const EXPLORE = [
  { label: "Story", to: "/#story" },
  { label: "Life at Wynridge", to: "/#life" },
  { label: "Community", to: "/#community" },
  { label: "Register Interest", to: "/#register" },
];

export default function Footer() {
  return (
    <footer>
      <div className="inner">
        <div className="top">
          <div>
            <img className="logo" src={BRAND.logoInk} alt="Wynridge" />
            <p className="blurb">Vibrant communities designed for active adults 55+. Independence, connection, and freedom — by design.</p>
          </div>
          <div className="col">
            <h4>Explore</h4>
            {EXPLORE.map((l) => (
              <Link key={l.to} to={l.to}>{l.label}</Link>
            ))}
          </div>
          <div className="col">
            <h4>Connect</h4>
            <a href="mailto:hello@wynridge.ca">hello@wynridge.ca</a>
            <a href="https://wynridge.ca">wynridge.ca</a>
            <p>Communities coming to<br />select Canadian cities</p>
          </div>
        </div>
        <div className="bot">
          <span>© 2026 Wynridge Active Living Inc. All rights reserved. · <Link to="/privacy">Privacy Policy</Link></span>
          <span>Life, by design.</span>
        </div>
      </div>
      <div className="ghost">WYNRIDGE</div>
    </footer>
  );
}
